import { render, staticRenderFns } from "./redirect-banks-edit-card.vue?vue&type=template&id=5d05e37c&scoped=true"
import script from "./redirect-banks-edit-card.vue?vue&type=script&lang=js"
export * from "./redirect-banks-edit-card.vue?vue&type=script&lang=js"
import style0 from "./redirect-banks-edit-card.vue?vue&type=style&index=0&id=5d05e37c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d05e37c",
  null
  
)

export default component.exports